import { useMemo } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export function useCheckForRenNumberInMessage(message: string): { renNumber: string; showRenButton: boolean } {
    const bootstrapState = useBootstrapState();
    const renLabel = bootstrapState.fieldDisplayNameByFieldName['AGENCY_EVENT_REPORTING_EVENT_NUMBER'];
    const result = useMemo(() => {
        if (!message) {
            return { renNumber: '', showRenButton: false };
        }

        let extractedRenNumber = '';
        const renLabelStartIndex = message.indexOf(renLabel);

        if (renLabelStartIndex !== -1) {
            const renNumberStartIndex = renLabelStartIndex + renLabel.length;
            const potentialRenPart = message.substring(renNumberStartIndex).trim();

            if (potentialRenPart.length > 0) {
                const firstSpaceIndex = potentialRenPart.indexOf(' ');
                if (firstSpaceIndex !== -1) {
                    extractedRenNumber = potentialRenPart.substring(0, firstSpaceIndex);
                } else {
                    extractedRenNumber = potentialRenPart;
                }
            }
        }

        const shouldShowRenButton = extractedRenNumber !== '';
        return {
            renNumber: extractedRenNumber,
            showRenButton: shouldShowRenButton,
        };
    }, [message, renLabel]);

    return result;
}
